/** Session-only boolean: TPA connect succeeded in this tab. Not keyed by user id. */
export const FIND_EXPENSES_COMPLETED_LOCK_KEY = 'spence_find_expenses_completed';

const canReadSessionStorage = (): boolean =>
  typeof window !== 'undefined' && typeof window.sessionStorage?.getItem === 'function';

const canWriteSessionStorage = (): boolean =>
  typeof window !== 'undefined' && typeof window.sessionStorage?.setItem === 'function';

const canRemoveSessionStorage = (): boolean =>
  typeof window !== 'undefined' && typeof window.sessionStorage?.removeItem === 'function';

export const isFindExpensesCompletedLockSet = (): boolean => {
  if (!canReadSessionStorage()) {
    return false;
  }

  return window.sessionStorage.getItem(FIND_EXPENSES_COMPLETED_LOCK_KEY) === 'true';
};

export const markFindExpensesCompletedLock = (): void => {
  if (!canWriteSessionStorage()) {
    return;
  }

  try {
    window.sessionStorage.setItem(FIND_EXPENSES_COMPLETED_LOCK_KEY, 'true');
  } catch {
    // Quota / private mode — Home can still load without the one-shot toast.
  }
};

export const clearFindExpensesCompletedLock = (): void => {
  if (!canRemoveSessionStorage()) {
    return;
  }

  window.sessionStorage.removeItem(FIND_EXPENSES_COMPLETED_LOCK_KEY);
};
